define('constant/myaccount/earnings.constant',[], function () {
    return {

        'serviceType2': [
            {val: '9211132', title: '游戏'},
            {val: '9221330', title: '主题'},
            {val: '9211135', title: 'App付费安装'},
            {val: '9352222', title: 'Voice视频'},
            {val: '9344171', title: '合作视频'},
            {val: '9351091', title: '华为阅读'},
            {val: '9354744', title: '荣耀阅读'},
            {val: '9221290', title: '华为音乐'},
            {val: '9211135-2', title: '应用内支付'}
        ],
        'billStatus2': [
            {val: 'null', title: '未结算'},
            {val: '1', title: '已受理'},
            {val: '2', title: '结算中'},
            {val: '3', title: '转账成功'},
            {val: '4', title: '转账失败'},
            {val: '0', title: '驳回'}
        ]
    };
});
